module.exports = __webpack_public_path__ + "static/media/dotmenu.98685302.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/icons/dotmenu.svg
// module id = 229
// module chunks = 0